import { useState, useCallback } from "react";

const TIMEZONE_KEY = "app_timezone";

export function useTimezone() {
  const [timezone, setTimezoneState] = useState<string>(() => {
    return localStorage.getItem(TIMEZONE_KEY) || Intl.DateTimeFormat().resolvedOptions().timeZone;
  });

  const setTimezone = useCallback(async (tz: string) => {
    setTimezoneState(tz);
    localStorage.setItem(TIMEZONE_KEY, tz);
    // In V2, we'll persist this via the API settings endpoint
    // api.updateSettings({ timezone: tz });
  }, []);

  const formatDate = useCallback(
    (date: string | Date, options?: Intl.DateTimeFormatOptions) => {
      const d = typeof date === "string" ? new Date(date) : date;
      return d.toLocaleString(undefined, {
        timeZone: timezone,
        ...options,
      });
    },
    [timezone]
  );

  const formatShort = useCallback(
    (date: string | Date) => {
      const d = typeof date === "string" ? new Date(date) : date;
      return d.toLocaleString(undefined, {
        timeZone: timezone,
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      });
    },
    [timezone]
  );

  return { timezone, setTimezone, formatDate, formatShort, loading: false };
}
